import type { ActionsPanelFilters } from "../types/common";

export const initialActionsPanelFilters: ActionsPanelFilters = {
    includeOnlyRevealed: false,
    includeOnlyNotRevealed: false,
    includeOnlyExported: false,
    excludeExported: false,
    page: undefined,
};
